import { init as initPagination } from './paginationComponent';
import { init as initSort } from './sortComponent';
import { init as initSearch } from '../../../core/js/components/searchComponent';
import { init as initProductCountComponent } from './productCountComponent';

import { debug } from '../../../core/js/utils/logger';

import template from 'category-grid-controls.j2';
import searchTemplate from 'category-new-search.j2';

import { dDom } from '../../../core/js/utils/renderUtils';
import { generate } from '../../../core/js/utils/componentUtils';
import { getCurrentCategory } from '../utils/utils';

import {
    requestFacetedItems,
    setSelectedFacet
} from '../actions/facetActions';
import { createGAEvent } from "../../../core/js/utils/analyticsUtils";
import { handleUtagEvent } from "../../../core/js/actions/initialActions";

const bottomPaginationOverrides = {
    templateLocation: '.dom-paging-bottom .dom-paging'
};

const searchOverrides = {
    templateLocation: '.dom-new-search',
    className: 'dom-new-search',
    watch: 'core.sayt.category',
    name: 'newSearchComponent',
    template: searchTemplate
};

function generateDictionary(state, dict, config) {
    const selectedFacets = _.get(state, 'category.facetOptions.selectedFacetsList', []);
    const hasSelectedFacets = selectedFacets.length > 0;
    const data = {
        filtersSelected: hasSelectedFacets
    };

    return Object.assign({}, state, data);
}

export function onStateChange(store, watchValue, oldVal, newVal) {
    const facetsChanged = watchValue === 'category.facetOptions.selectedFacetsList';
    /* eslint-disable no-extra-parens */
    if (facetsChanged && (oldVal > 0 && newVal > 0) ||
        (oldVal < 0 && newVal < 0) ||
        (!oldVal && !newVal)) {
        return;
    }

    debug('Category: update browse');

    if (newVal && facetsChanged) {
        _.forEach(this.childrenObjects, (child) => {
            this.reactivateChild(child, store);
        });
    }

    this.render(store, this, {});
}

function firstRender(store) {
    this.render(store, this, {});
}

function afterRender(store) {
    if (!_.isEmpty(this.loader)) {
        this.attachLoader(store);
    }

    this.attachExpandedFilterEvents(store);
}

function attachExpandedFilterEvents(store) {
    $('.js-expanded-filter__a').on('click', (e) => {
        e.preventDefault();
        this.attachLoader(store);

        const el = $(e.currentTarget);
        const categoryId = getCurrentCategory();
        const facetName = el.closest('[data-facet-name]').attr('data-facet-name');
        const facetValue = el.closest('[data-facet-value]').attr('data-facet-value');
        const isSelected = el.is(':checked');
        const qs = el.attr('data-query-string');

        store.dispatch(setSelectedFacet(facetName));
        store.dispatch(requestFacetedItems(categoryId, facetName, facetValue, isSelected, qs, true, e, this));
    });
}

// TODO: UW-11656 Tech Debt to create facet utils for this click event to use for all facet scenarios
export function attachEvents(store) {
    this.attachExpandedFilterEvents(store);

    $(document).on('RECEIVED_CATEGORY_ITEMS', (e) => {
        this.removeLoader(store);
    });

    $(document).on('click', '.js-category-grid .js-product-tile', (e) => {
        const state = store.getState();
        const product = $(e.currentTarget);
        const name = product.attr('data-product-name');
        const index = parseInt(product.attr('data-product-index'), 10);
        const badge = _.get(state, `category.products.records[${index}].allMeta.tile.product.visualBadge`)
            || 'no badge';
        const event = createGAEvent('category', 'product click',
            `${badge} | ${name} | ${index + 1}`);
        store.dispatch(handleUtagEvent(event, 'link'));
    });
}

export function init(store, overrides = {}) {
    const config = {
        children: [
            initPagination,
            [initPagination, bottomPaginationOverrides],
            initSort,
            [initSearch, searchOverrides],
            initProductCountComponent
        ],
        templateLocation: '.dom-category-above-grid',
        watch: ['category.facetOptions.selectedFacetsList', 'core.deviceCharacteristics'],
        name: 'categoryGridControlsComponent',
        onStateChange: onStateChange,
        firstRender: firstRender,
        afterRender: afterRender,
        generateDictionary: generateDictionary,
        attachExpandedFilterEvents: attachExpandedFilterEvents,
        attachEvents: attachEvents,
        template: template,
        rebind: true,
        renderType: dDom
    };

    return generate(config, store, overrides);
}
